import UserIcon from "@redotech/redo-icons/user-01.svg";
import { OMSUser } from "@redotech/redo-model/fulfillments/oms-user";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.assignees;

export const OMSUserFilter = (
  users: OMSUser[],
): ArrayStringTableFilter<OMSUser> => ({
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  operators: entry.operators,
  itemLabel: "user",
  Icon: UserIcon,
  values: users,
  stringify: (item: OMSUser | string) => {
    return typeof item === "string" ? item : item._id;
  },
  display: (item: OMSUser | string) => {
    if (typeof item === "string") {
      return users.find((user) => user._id === item)?.name || item;
    } else {
      return item.name;
    }
  },
  displayName: entry.displayName,
});
